export function formatLineReturn(stringToBeFormatted: string | null | undefined): string {
  if (!stringToBeFormatted) return ''
  return stringToBeFormatted.replace(/\\n/g, '\n')
}
